import React from 'react';

export const CustomPageWidget = ({ name, widgets = {}, ...rest }) => {
  const customPageWidgets = { ...widgets };

  if (customPageWidgets[name]) {
    const Widget = customPageWidgets[name];

    return <Widget name={name} {...rest} />;
  }

  return null;
};
